import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterOutlet, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { DswFooterComponent } from '@vi-succ/design-system-web';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaintenanceService } from './maintenance/maintenance.service';
import { MaintenanceGuard } from './maintenance/maintenance.guard';
import { ProductContextService } from './core/product-context.service';
import { LanguageChangerComponent } from './language-changer/language-changer.component';
import { Subscription } from 'rxjs';
import { MaintenanceBannerComponent } from './maintenance-banner/maintenance-banner.component';


@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, DswFooterComponent, TranslateModule, NgIf, MatToolbarModule, MatProgressSpinnerModule, LanguageChangerComponent, MaintenanceBannerComponent],
  providers: [MaintenanceService, MaintenanceGuard],
  templateUrl: './app.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppComponent implements OnInit {
  public locale: string = '';
  public title = "QR-Code Landingpage";
  public isLoading = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private productContextService: ProductContextService,
    private translate: TranslateService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.translate.setDefaultLang('de-DE');
    this.translate.use('de-DE');

    this.subscriptions.add(
      this.productContextService.locale$.subscribe(locale => {
        if (locale) {
          this.locale = locale;
          this.translate.use(locale);
        }
      })
    );

    this.subscriptions.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.isLoading = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.isLoading = false;
        }
      })
    );
  }
}


